module.exports = __webpack_public_path__ + "img/instagram.38013ad6.svg";